/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2021 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: field-system-parameters-component.ts
 *
 * Created by kyang on 2020-09-14.
 */

function FileSystemParametersController (
    this: JS5Object,
    _: JS5Object,
) {

    this.hasParameters = () => {
        return this.selectedTypeName && !_.isEmpty(this.typeParameters);
    };

    this.onParameterChanged = (parameter: JS5Object) => {
        if (parameter.value) {
            this.fileSystemObject.parameters[parameter.name] = parameter.value;
        } else {
            delete this.fileSystemObject.parameters[parameter.name];
        }
    }

    //=================//
    // Lifecycle Hooks //
    //=================//

    const updateTypeParameters = () => {
        if (!this.fileSystemTypes) {
            return;
        }
        let newParameterNames: string[] = [];
        let fileSystemParameters = _.get(this.fileSystemObject, 'parameters', {});
        let selectedType = _.find(this.fileSystemTypes, {
            name: this.selectedTypeName
        });
        this.typeParameters = _.chain(selectedType)
            .get('parameters', [])
            .sortBy('name')
            .map((parameter: JS5Object) => {
                newParameterNames.push(parameter.name);
                return _.assign({
                    value: (parameter.type === 'boolean') ? fileSystemParameters[parameter.name] === 'true' : fileSystemParameters[parameter.name]
                }, parameter);
            })
            .value();
        if (this.fileSystemObject) {
            this.fileSystemObject.parameters = _.pick(this.fileSystemObject.parameters, newParameterNames);
        }
    };

    this.$onChanges = (changes: JS5Object) => {
        if (changes.selectedTypeName && !changes.fileSystemObject && this.fileSystemObject) {
            this.fileSystemObject.parameters = {};
        }
        updateTypeParameters();
    };

    this.$onInit = () => {
        updateTypeParameters();
    };
}

angular.module('prism-ui.fileSystem').component('fileSystemParameters', {
    templateUrl: 'system/fileSystem/editView/properties/components/fileSystemParameters/file-system-parameters-template.html',
    controller: FileSystemParametersController,
    bindings: {
        fileSystemObject: '<',
        fileSystemTypes: '<',
        selectedTypeName: '<'
    }
});
